<va-card *ngIf="cardData.showCard" [size]="'full'" class="subscription-card">
  <div class="subscription-card-title" *ngIf="cardData.subtitle; else loadingTitle">
    {{ cardData.title | translate }}
  </div>
  <ng-template #loadingTitle>
    <div class="title-shimmer">
      <span class="bar stencil-shimmer"></span>
    </div>
  </ng-template>
  <div class="subscription-card-subtitle" *ngIf="cardData.subtitle; else loadingSubtitle">
    <span>
      {{ cardData.subtitle | translate : { maxLimit: cardData.maxLimit | number } }}
      <a *ngIf="cardData.learnMoreUrl" [href]="cardData.learnMoreUrl">
        {{ 'SUBSCRIPTIONS.LEARN_MORE' | translate }}
      </a>
      <span *ngIf="!!cardData.resetDate">
        {{ 'SUBSCRIPTIONS.LIMIT_RESET_DATE' | translate : { resetDate: cardData.resetDate.toString() } }}
      </span>
    </span>
  </div>
  <ng-template #loadingSubtitle>
    <div class="subtitle-shimmer">
      <span class="bar stencil-shimmer"></span>
    </div>
  </ng-template>
  <div *ngIf="cardData.hasCurrentValue; else loadingCard" class="limits-container-wrapper">
    <div *ngFor="let limit of cardData.subscriptionLimits">
      <div *ngIf="limit.showLimit" class="limits-container">
        <div class="limit-row-container limit-title col-xs-12">
          <div class="limit-image-container">
            <img *ngIf="limit.limitImageUrl" [src]="limit.limitImageUrl" [alt]="limit.limitTitle" />
          </div>
          <div *ngIf="limit.limitTitle" class="limit-title-text">
            {{ limit.limitTitle | translate }} |
            {{ 'SUBSCRIPTIONS.EXPRESS' | translate }}
          </div>
        </div>
        <div [ngSwitch]="limit.limitMax">
          <div *ngSwitchCase="-1">
            <div class="no-limit {{ !(limit.limitTitle || limit.limitImageUrl) ? 'no-pad' : '' }}">
              {{ 'SUBSCRIPTIONS.NO_LIMIT' | translate }}
            </div>
          </div>
          <div *ngSwitchCase="0">
            <div class="no-limit {{ !(limit.limitTitle || limit.limitImageUrl) ? 'no-pad' : '' }}">
              {{ 'SUBSCRIPTIONS.NO_EXPRESS' | translate }}
            </div>
          </div>
          <div *ngSwitchDefault class="limit-row-container col-xs-12">
            <div class="row col-xs-12">
              <div
                class="limit-bar-container col-xs-4 {{
                  !(limit.limitTitle || limit.limitImageUrl) ? 'limit-row-no-pad' : ''
                }}"
              >
                <glxy-progress-bar
                  [progress]="(limit.currentValue / limit.limitMax > 1 ? 1 : limit.currentValue / limit.limitMax) * 100"
                ></glxy-progress-bar>
              </div>
              <div class="limit-bar-value col-xs-4">
                {{
                  'SUBSCRIPTIONS.LIMIT_COUNT'
                    | translate
                      : {
                          currentValue: limit.currentValue,
                          limitMax: limit.limitMax
                        }
                }}
              </div>
              <div class="limit-remaining col-xs-4">
                {{ 'SUBSCRIPTIONS.FREE_REMAINING' | translate : { freeLeft: limit.limitMax - limit.currentValue } }}
              </div>
            </div>
          </div>
          <div
            *ngIf="limit.limitMax > 0 && limit.exceededLimitValue > 0"
            class="exceed-limit {{ !(limit.limitTitle || limit.limitImageUrl) ? 'no-pad' : '' }}"
          >
            {{ 'SUBSCRIPTIONS.LIMIT_EXCEEDED' | translate : { numberExceeded: limit.exceededLimitValue } }}
            {{
              'SUBSCRIPTIONS.' + cardData.exceedUnit + (limit.exceededLimitValue > 1 ? '_PLURALIZE' : '') | translate
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="cardData.upgradeCTA">
    <div *ngIf="cardData.nextTierId; else needMore" class="upgradeCTA">
      <mat-icon class="upgradeCTAIcon">trending_up</mat-icon>
      <p
        class="upgradeTextCTA"
        [innerHTML]="
          cardData.upgradeCTA
            | translate
              : {
                  plan: 'SUBSCRIPTION_TIERS.' + cardData.nextTierId + '.NAME' | translate,
                  limit: cardData.nextTierLimit | translate
                }
        "
      ></p>
      <a class="upgradeLinkCTA" [routerLink]="'/upgrade-subscription-tier'">
        {{ 'COMMON.ACTION_LABELS.UPGRADE' | translate }}
      </a>
    </div>
    <ng-template #needMore>
      <div class="upgradeCTA">
        <mat-icon class="upgradeCTAIcon">trending_up</mat-icon>
        <p class="upgradeTextCTA">
          {{ 'SUBSCRIPTIONS.NEED_MORE_CTA' | translate : { type: cardData.type } }}
        </p>
        <app-contact-us class="upgradeLinkCTA">
          {{ 'SUBSCRIPTIONS.CONTACT_US' | translate }}
        </app-contact-us>
      </div>
    </ng-template>
  </div>
  <ng-template #loadingCard>
    <div class="card-shimmer" *ngIf="cardData.loading">
      <span class="bar stencil-shimmer"></span>
    </div>
  </ng-template>
</va-card>
